import * as Icons from '@mui/icons-material';

export * from './svg-icon';

export const MaterialIcon = {
  arrow_back_rounded: Icons.ArrowBackRounded,
  arrow_forward_rounded: Icons.ArrowForwardRounded,
  cancel: Icons.CancelOutlined,
  bug_report: Icons.BugReportOutlined,
  file_copy: Icons.ContentCopyRounded,
  light_mode: Icons.LightModeOutlined,
  dark_mode: Icons.DarkModeOutlined,
  prev: Icons.NavigateBefore,
  next: Icons.NavigateNext,
  error: Icons.Error,
  link: Icons.Link,
  link_off: Icons.LinkOff,
  github: Icons.GitHub,
  code: Icons.Code,
  arrow_right: Icons.ArrowRightOutlined,
  search: Icons.Search,
  menu_book: Icons.MenuBookRounded,
  contact_support: Icons.ContactSupportOutlined,
  task: Icons.Task,
  auto_stories: Icons.AutoStoriesRounded,
  more_vert: Icons.MoreVert,
  groups2: Icons.Groups2Outlined,
  warning: Icons.WarningOutlined,
  circle: Icons.Circle,
  open_in_new: Icons.OpenInNew,
  cancel_outlined: Icons.CancelOutlined,
  LocationCityRounded: Icons.LocationCityRounded,
  ScheduleRounded: Icons.ScheduleRounded,
  MailOutlineRounded: Icons.MailOutlineRounded,
  LinkRounded: Icons.LinkRounded,
  AddRounded: Icons.AddRounded,
  check_circle: Icons.CheckCircleOutlineRounded,
  close_rounded_icon: Icons.CloseRounded,
  ChevronRight: Icons.ChevronRight,
  ChevronLeft: Icons.ChevronLeft,
  SettingsRounded: Icons.SettingsRounded,
  visibilityOn: Icons.Visibility,
  visibilityOff: Icons.VisibilityOff,
  arrowDropDown: Icons.ArrowDropDown,
  arrowDropUp: Icons.ArrowDropUp,
  eventAvailable: Icons.EventAvailableRounded,
  releaseAlert: Icons.NewReleasesOutlined,
  openInNew: Icons.OpenInNewRounded,
  expand: Icons.OpenInFullRounded,
  facebook: Icons.Facebook,
  x: Icons.X,
  linkedin: Icons.LinkedIn,
};
